import * as React from 'react';
import { handleKeyEvent } from './scanner-helper';
import { Props } from './props';

import './styles.css';

export class Scanner extends React.Component<Props> {

  constructor(props: Props) {
    super(props);
  }

  componentWillMount() {
    // We can use keydown since in GS1 there is only ascii chars that is used. (not using two keys to create one)
    document.addEventListener('keydown', this.handleKeydown, false);
  }

  componentWillUnmount() {
    document.removeEventListener('keydown', this.handleKeydown, false);
  }

  public render() {
    return (React.Fragment);
  }

  private handleKeydown = (event: KeyboardEvent) => {
    handleKeyEvent(event, this.props.onScanAttempt, this.props.onBarcodeScanned);
  }
}


// WEBPACK FOOTER //
// ./src/components/scanner/component.tsx